/*业主名下房源*/
export function getRoomsByMemberId(memberId) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/GetRoomsByMemberId',
        method: 'get',
        params: { memberId: memberId }
    });
}

export function relieveMemberFamilyEntity(data) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/RelieveMemberFamilyEntity',
        method: 'post',
        params: data
    });
}

/*根据房源获取所有关联人员*/
export function getAllRoomMember(roomId) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/GetAllRoomMember',
        method: 'get',
        params: { roomId: roomId }
    });
}

export function changeRoomMemberStatus(data) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/ChangeRoomMemberStatus',
        method: 'post',
        params: data
    });
}

/*获取车辆*/
export function getRoomOwnerCarsByRoomId(roomId) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/GetRoomOwnerCarsByRoomId',
        method: 'get',
        params: {roomId: roomId}
    });
}
export function deleteRoomOwnerCar(id) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/DeleteRoomOwnerCar',
        method: 'delete',
        params: {id: id}
    });
}

export function createRoomOwnerCar(data = {}) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/CreateRoomOwnerCar',
        method: 'post',
        data: data
    });
}

export function getDeliveryDataRecord(roomId,businessType) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/GetDeliveryDataRecord',
        method: 'get',
        params: {roomId:roomId,businessType:businessType}
    });
}
export function getEmergencyContactInfo(roomId) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/GetEmergencyContactInfo',
        method: 'get',
        params: {roomId: roomId}
    });
}
